import { useEffect, useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import { selectCardPaySum } from '~/src/features/payments-abn/components/SeasonTicketPayment/store/selectors/selectPaymentSum';
import { fillBonusesValue } from '~/src/features/payments-abn/store/actionCreators';
import {
    calculateByUseBonuses,
    setBonusesValue,
    validateBonusesValue,
} from '~/src/features/payments-abn/store/actions';
import { TState } from '~/src/store';

import { IBonusesPaymentProps } from './index';

const bonusesRegExp = /^[1-9]\d*$/;

/**
 * возвращает пропсы для формы оплаты бонусами
 * TODO форма <BonusesPayment/> используется также для оплаты абонементов. Обработчики для оплаты абонеметов отличаются, необходимо объединить их.
 */
export const useBonusesPayment = (): IBonusesPaymentProps => {
    const dispatch = useDispatch();

    const { availableBonuses, paymentData, showBonusesPayment } = useSelector((state: TState) => ({
        availableBonuses: state.loyalty.info.bonuses,
        paymentData: state.payment.paymentData,
        showBonusesPayment: state.loyalty.availability.isRegistered && state.auth.isAuth,
    }), shallowEqual);

    const cardPaymentSum = useSelector(selectCardPaySum);

    const { paymentSum, isUseBonuses, bonusesValue, isBonusesValueValid } = paymentData;
    const isOnlyBonusesPay = !cardPaymentSum && isUseBonuses && !!bonusesValue;
    const [bufferBonusesValue, setBufferBonusesValue] = useState('');
    const [isTouchedBonusInput, setIsTouchedBonusInput] = useState(false);

    useEffect(() => {
        setBufferBonusesValue(`${bonusesValue}`);
    }, [bonusesValue]);

    const onToggle = () => {
        dispatch(calculateByUseBonuses(isTouchedBonusInput));
    };

    const onFocus = (event: React.FocusEvent<HTMLInputElement>) => {
        if (event.target.value === '0') {
            setBufferBonusesValue('');
        }

        dispatch(validateBonusesValue(true));
    };

    const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        !isTouchedBonusInput && setIsTouchedBonusInput(true);

        const { value } = event.target;

        if (!value) {
            setBufferBonusesValue('');
        } else if (bonusesRegExp.test(value)) {
            setBufferBonusesValue(value);
            dispatch(setBonusesValue(+value));
            dispatch(validateBonusesValue());
        }
    };

    const onBlur = (event: React.FocusEvent<HTMLInputElement>) => {
        if (!event.target.value) {
            setBufferBonusesValue('0');
            dispatch(fillBonusesValue(0));
        }
    };

    return ({
        showBonusesPayment,
        isOnlyBonusesPay,
        availableBonuses,
        value: bufferBonusesValue,
        maxLength: `${availableBonuses.toString().length}`,
        isChecked: isUseBonuses,
        isDisabled: !availableBonuses || !paymentSum,
        isValid: isBonusesValueValid,
        onToggle,
        onFocus,
        onChange,
        onBlur,
    });
};
